import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/store';
import { useCompaniesApi } from '../api';
import {
  resetError,
  setCurrentCompanies,
  setError,
  setLoading,
} from '../slices';
import { delay } from 'src/helpers/delay';


export const useUserCompaniesService = () => {
  const dispatch = useDispatch();
  const { loading, currentCompanies, currentCompanyId, error } = useAppSelector((state) => state.companies);

  const api = useCompaniesApi();

  const getCompanies = useCallback(async () => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ getCurrentCompanyList: true }));

      try {
        const response = await api.getUserCompanies();
        dispatch(setCurrentCompanies(response.data));
        return response.data;
      } catch (e) {
        if (e?.response?.status === 401) {
          await delay(1000);
          const response = await api.getUserCompanies();
          dispatch(setCurrentCompanies(response.data));
          return response.data;
        }
        throw e;
      }

    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ getCurrentCompanyList: false }));
    }
  }, []);

  return {
    loading,
    currentCompanies,
    currentCompanyId,
    error,
    getCompanies,
  };
};
